export enum PortalUsedOption {
  Clever = "Clever",
  Classlink = "Classlink",
  Google = "Google",
  Canvas = "Canvas",
  Schoology = "Schoology",
  Microsoft = "Microsoft",
  Other = "Other",
}
